import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    this.updatePreview()
    this.inputTarget.addEventListener("input", () => this.updatePreview())
    this.inputTarget.addEventListener("change", () => this.updatePreview())
  }

  updatePreview() {
    if (!this.hasPreviewTarget) return

    const value = this.inputTarget.value.trim().replace(/^#/, "")
    const valid = /^[0-9a-fA-F]{6}$/.test(value) || /^[0-9a-fA-F]{3}$/.test(value)
    this.previewTarget.style.backgroundColor = valid ? `#${value}` : "#e5e7eb"
  }
}
